import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        gridContainer: {
            marginTop: theme.spacing(2),
        }
    }),
);